export default "__VITE_ASSET__20822d5b__"